'use strict'
import api from '@/api/api'
import router from '@/router'
import notify from "@/utils/notify"
import {encrypt} from "@/utils/crypto";

export default {
  async getUsers(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `users${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createUser(json) {
    const data = {
      method: 'post',
      url: 'users',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('User created successfully')
      return true;
    }
  },
  async getProfile() {
    const data = {
      method: 'get',
      url: 'profile',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      sessionStorage.setItem('profile', encrypt(JSON.stringify(response.data)))

      return response.data
    }
  },
  async updateProfile(json) {
    const data = {
      method: 'put',
      url: 'profile',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      await this.getProfile()
      notify.alert.success('Profile updated successfully')
      return true;
    }
  },
  async changePassword(json, id) {
    const data = {
      method: 'post',
      url: 'change-password/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      await this.verifyEmail(id)
      await this.getProfile()
      notify.alert.success('Password updated successfully')
      router.push('/')
    }
  },
  async updateUser(json, id) {
    const data = {
      method: 'put',
      url: 'users/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('User updated successfully')
      return true;
    }
  },
  async updateAvatar(json) {
    const data = {
      method: 'put',
      url: 'profile/avatar',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      await this.getProfile()
      notify.alert.success('Profile picture updated successfully')
      window.location.reload()
    }
  },
  async verifyEmail(id) {
    const data = {
      method: 'put',
      url: 'user/verify-email/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('User updated successfully')
    }
  },
}
